import React, { useEffect, useState } from 'react';
import { Card, CardContent } from './ui/card';
import { CheckCircle2, AlertCircle, Circle, FileText, IdCard, Shield, Camera, User } from 'lucide-react';
import { aiApi } from '../lib/api';

const ICONS = { camera: Camera, 'id-card': IdCard, 'file-text': FileText, shield: Shield, user: User };

export default function DocumentChecklist({ caseId, testid = 'document-checklist' }) {
  const [data, setData] = useState(null);

  const load = async () => {
    if (!caseId) return;
    try {
      const { data } = await aiApi.docChecklist(caseId);
      setData(data);
    } catch (e) { /* ignore */ }
  };

  useEffect(() => { load(); }, [caseId]);

  if (!data) return null;
  const checklist = data.checklist || [];
  const missing = data.missing_required || [];

  return (
    <Card className="rounded-2xl border-slate-200" data-testid={testid}>
      <CardContent className="p-5">
        <div className="flex items-center justify-between mb-3">
          <div className="font-heading font-semibold text-slate-900">Dokumenten-Checkliste</div>
          <span className={`px-2.5 py-1 rounded-full text-xs font-medium ${data.complete ? 'bg-green-100 text-green-900' : 'bg-amber-100 text-amber-900'}`}>
            {data.complete ? 'Vollständig' : `${missing.length} fehlt`}
          </span>
        </div>
        <ul className="space-y-2">
          {checklist.map((c) => {
            const Icon = ICONS[c.icon] || FileText;
            const present = c.present;
            const required = c.required;
            const Status = present ? CheckCircle2 : (required ? AlertCircle : Circle);
            const color = present ? 'text-green-600' : (required ? 'text-orange-600' : 'text-slate-400');
            return (
              <li key={c.key} className="flex items-center gap-3 py-1" data-testid={`checklist-item-${c.key}`}>
                <Status className={`h-5 w-5 ${color}`} />
                <Icon className="h-4 w-4 text-slate-500" />
                <div className="flex-1">
                  <div className="text-sm text-slate-900">{c.label} {!required && <span className="text-xs text-slate-400">(optional)</span>}</div>
                </div>
                {c.count > 0 && <span className="text-xs text-slate-500">{c.count}</span>}
              </li>
            );
          })}
        </ul>
      </CardContent>
    </Card>
  );
}
